import * as Immutable from "immutable";
export default class Role {
  constructor(id, name, description, permissions, readOnly) {
    this._value = {
      id,
      name,
      description,
      permissions,
      readOnly
    };
  }
  get id() {
    return this._value.id;
  }
  get name() {
    return this._value.name;
  }
  get description() {
    return this._value.description;
  }
  get permissions() {
    return this._value.permissions;
  }
  get readOnly() {
    return this._value.readOnly;
  }
  toBuilder() {
    const { id, name, description, permissions, readOnly } = this._value;
    return new Builder(
      Immutable.Map({
        id,
        name,
        description,
        permissions,
        readOnly
      })
    );
  }
  static create(id, name, description, permissions, readOnly) {
    return new Role(id, name, description, permissions, readOnly);
  }
  toJSON() {
    const { id, name, description, permissions, readOnly } = this._value;
    return {
      id,
      name,
      description,
      permissions,
      read_only: readOnly
    };
  }
  static fromJSON(value) {
    const { id, name, description, permissions, read_only: readOnly } = value;
    return Role.create(id, name, description, permissions, readOnly);
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  name(value) {
    return new Builder(this.value.set("name", value));
  }
  description(value) {
    return new Builder(this.value.set("description", value));
  }
  permissions(value) {
    return new Builder(this.value.set("permissions", value));
  }
  readOnly(value) {
    return new Builder(this.value.set("readOnly", value));
  }
  build() {
    const { id, name, description, permissions, readOnly } = this.value.toObject();
    return new Role(id, name, description, permissions, readOnly);
  }
}
